const nameRegExp = /^[-A-Za-z0-9_'?/:,=!+".()¿ăâîșțėçğöşüАА́А̀А̂А̄ӒБВГҐДЂЃЕЕ́ЀЕ̂Е̄ЁЄЄ́ЖЗЗ́ЅИІІ́ЇИ́ЍИ̂ӢЙЈКЛЉМНЊОО́О̀О̂ŌӦПРСС́ТЋЌУУ́У̀У̂ӮЎӰФХЦЧЏШЩЪЪ̀ЫЫ́ЬѢЭЭ́ЮЮ́Ю̀ЯЯ́Я̀ąćęłńóśóżźáčďéěíňóřšťúůýžàâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇzñáéíóúüаАбБвВгГдДеЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦчЧшШщЩъЪыЫьЬэЭюЮяЯäöüÄÖÜß\s]*$/i;

module.exports = {
	nameRegExp,
};
